import { Presence } from "revolt-api/src";

/**
 * Decide whether this client should re-assert its own presence after a
 * (re)connect.
 *
 * @param desired presence this client last sent, if any
 * @param current presence the user is currently shown with, if any
 * @returns presence to send, or null when nothing should be sent
 */
export function presenceToResync(
    desired: Presence | null | undefined,
    current: Presence | null | undefined,
): Presence | null {
    if (desired === undefined || desired === null) {
        return null;
    }

    if (current === desired) {
        return null;
    }

    return desired;
}
